// Shared between Disclaimers.jsx and Campaigns.jsx's "Takvim" view — both
// content types are now group-targeted with an optional (disclaimers) or
// required (campaigns) date range, and the RFP's own content-calendar
// requirement (COM-002) asks for exactly this: a calendar view plus a
// warning when scheduled items overlap. This computes overlaps ("çakışan
// yayınlar uyarılır") — it does not prevent them; the backend's existing
// most-recently-updated/created tie-break still decides which one actually
// renders, same as before this feature.

function rangesOverlap(aStart, aEnd, bStart, bEnd) {
  // Missing bound = unbounded on that side.
  if (aEnd && bStart && aEnd < bStart) return false;
  if (aStart && bEnd && aStart > bEnd) return false;
  return true;
}

function sharesGroup(a, b) {
  const bGroups = new Set(b.groups || []);
  return (a.groups || []).some(g => bGroups.has(g));
}

// items: [{id, groups: [string], start_date, end_date}] — start_date/
// end_date as Date objects or null. Returns a Set of ids that overlap
// (same target group + overlapping window) with at least one other item.
// Only items that carry at least one date bound are considered — two
// always-on items targeting the same group aren't a "scheduling conflict"
// in the calendar sense, that's just the ordinary override behavior the
// rest of this app already explains elsewhere (most-recently-updated wins).
export function findScheduleConflicts(items) {
  const dated = items.filter(i => i.start_date || i.end_date);
  const conflicts = new Set();
  for (let i = 0; i < dated.length; i++) {
    for (let j = i + 1; j < dated.length; j++) {
      const a = dated[i];
      const b = dated[j];
      if (sharesGroup(a, b) && rangesOverlap(a.start_date, a.end_date, b.start_date, b.end_date)) {
        conflicts.add(a.id);
        conflicts.add(b.id);
      }
    }
  }
  return conflicts;
}

export function isActiveOnDay(item, day) {
  const dayStart = new Date(day.getFullYear(), day.getMonth(), day.getDate());
  const dayEnd = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59, 999);
  if (item.start_date && item.start_date > dayEnd) return false;
  if (item.end_date && item.end_date < dayStart) return false;
  return true;
}
